<!--
  安全加固：强制修改密码对话框

  后端 must_change_pwd = 1 的账户，其 token 仅能访问改密接口，
  必须先改密才能继续使用系统。

  用法：
    <force-change-password ref="forcePwd" @done="onPwdChanged" />
    // 登录成功后：
    if (res.data.mustChangePwd) { this.$refs.forcePwd.open(); return }
-->
<template>
  <el-dialog
    title="请修改密码"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="90%"
    append-to-body
  >
    <el-alert
      type="warning"
      title="您的密码需要修改后才能继续使用系统"
      description="密码至少 8 位，需包含数字、大小写字母、特殊字符中的至少 3 种，且不能与用户名相似。"
      :closable="false"
      show-icon
      style="margin-bottom: 16px"
    ></el-alert>
    <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="90px">
      <el-form-item label="当前密码" prop="password">
        <el-input v-model="pwdForm.password" type="password" placeholder="请输入当前密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input v-model="pwdForm.newPassword" type="password" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="rePassword">
        <el-input v-model="pwdForm.rePassword" type="password" placeholder="请再次输入新密码"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleCancel">退出登录</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">确认修改</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { resetPassword } from '@/api/requestForm'

export default {
  name: 'ForceChangePassword',
  data() {
    return {
      visible: false,
      loading: false,
      pwdForm: {
        password: '',
        newPassword: '',
        rePassword: ''
      },
      pwdRules: {
        password: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, max: 20, message: '密码长度需在 8 到 20 位之间', trigger: 'blur' }
        ],
        rePassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.pwdForm.newPassword) {
                callback(new Error('两次输入的新密码不一致'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    handleSubmit() {
      this.$refs['pwdForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.loading = true
        resetPassword({
          password: this.pwdForm.password,
          newPassword: this.pwdForm.newPassword,
          rePassword: this.pwdForm.rePassword
        }).then(res => {
          if (res.data.code == 0) {
            this.$message({
              message: '密码修改成功，请使用新密码重新登录',
              type: 'success',
              duration: 3000
            })
            this.close()
            this.$emit('done')
          } else {
            this.$message({
              message: res.data.msg || '密码修改失败',
              type: 'error',
              duration: 3000
            })
          }
        }).catch(err => {
          const data = (err.response || {}).data || {}
          this.$message({
            message: data.msg || '密码修改失败',
            type: 'error',
            duration: 3000
          })
        }).finally(() => {
          this.loading = false
        })
      })
    },
    handleCancel() {
      this.close()
      this.$emit('done')
    },
    // 关闭并清除登录态：改密后旧 token 不再可信
    close() {
      this.visible = false
      localStorage.removeItem('token')
      this.pwdForm = { password: '', newPassword: '', rePassword: '' }
      this.$refs['pwdForm'] && this.$refs['pwdForm'].resetFields()
    }
  }
}
</script>
